import { ChangeDetectionStrategy, Component} from '@angular/core';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-fallback',
  templateUrl: './fallback.component.html',
  styleUrls: ['./fallback.component.scss'],
})
export class FallbackComponent {
  //Absolut leere Komponente. Falls keinerlei Reiter sichtbar sind, soll man hierauf zurückfallen.
}
